module.exports = __webpack_public_path__ + "static/img/a3.c19a87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a3.png
// module id = J2a/
// module chunks = 1